import _ from 'lodash';
import { CLEAR_API_ERRORS } from './constants';
import { getActionName } from './utils';

const errorReducer = (state = {}, action) => {
  const { type, message = null, id, actions = [] } = action;

  if (type === CLEAR_API_ERRORS) {
    const newState = { ...state };
    _.forIn(state, (value, key) => {
      const actionRegEx = RegExp(`(${actions.join('|')})`);

      if (actionRegEx.test(key)) {
        newState[key] = null;
      }
    });
    return newState;
  }

  const matches = /(.*)_(REQUEST|FAILURE)$/.exec(type);

  // Not a *_REQUEST / *_FAILURE, so we ignore them
  if (!matches) return state;

  const [, requestName, requestState] = matches;

  return {
    ...state,
    [getActionName({ type: requestName, id })]:
      requestState === 'FAILURE' ? message : null,
  };
};

export default errorReducer;
